
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ooka-for-business",
      function () {
        return require("private-next-pages/ooka-for-business.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ooka-for-business"])
      });
    }
  